export function toggleBoolParamInUrl(param: string) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get(param) === "true") {
        urlParams.set(param, "false");
    } else {
        urlParams.set(param, "true");
    }
    window.location.search = urlParams.toString();
}
